{
  "bankAccounts": {
    "title": "Bank Accounts",
    "connectTitle": "Connect Bank Account",
    "emptyState": {
      "title": "No Bank Account Connected",
      "description": "Connect your bank account to enable deposits and withdrawals from your investment pool.",
      "connectButton": "Connect Bank Account"
    },
    "connected": {
      "title": "Bank Account Connected",
      "description": "Your bank account is linked and ready for transactions",
      "comingSoon": "Account details and management options coming soon"
    },
    "connect": {
      "title": "Connect Your Bank Account",
      "description": "Securely link your bank account to enable deposits and withdrawals. Your credentials are never stored on our servers.",
      "button": "Connect Bank Account",
      "initializing": "Initializing...",
      "connecting": "Connecting your bank account...",
      "success": "Bank account connected successfully!",
      "error": {
        "title": "Connection Error",
        "retry": "Try Again",
        "initFailed": "Failed to initialize bank connection",
        "connectFailed": "Failed to connect bank account"
      }
    },
    "list": {
      "addAccountButton": "Add Account",
      "syncButton": "Refresh Accounts",
      "noAccounts": "No accounts found. Click refresh to sync from your bank.",
      "fetchError": "Failed to load bank accounts",
      "syncSuccess": "Bank accounts synced successfully",
      "syncError": "Failed to sync bank accounts"
    },
    "status": {
      "active": "Active",
      "disconnected": "Disconnected",
      "disabled": "Disabled"
    },
    "reconnect": {
      "badge": "Disconnected",
      "button": "Reconnect",
      "modal": {
        "title": "Reconnect Bank Account",
        "description": "Your bank connection has been disconnected. You'll need to log in again to restore access to your bank accounts.",
        "confirm": "Reconnect Now",
        "cancel": "Cancel"
      },
      "success": "Bank account reconnected successfully",
      "error": "Failed to reconnect bank account"
    },
    "default": {
      "badge": "Default",
      "setButton": "Set as Default",
      "setSuccess": "Default bank account updated successfully",
      "setError": "Failed to set default bank account"
    },
    "disable": {
      "button": "Disable",
      "modal": {
        "title": "Disable Bank Account",
        "description": "Are you sure you want to disable this bank account? It will no longer be available for transactions.",
        "reasonLabel": "Reason",
        "reasonPlaceholder": "Select a reason",
        "reasonTextLabel": "Additional details (optional)",
        "reasonTextPlaceholder": "Provide more information...",
        "replacementLabel": "Set new default account",
        "replacementPlaceholder": "Select a replacement",
        "replacementNote": "This account is currently your default. Please select a new default or the default will be cleared.",
        "confirm": "Disable Account",
        "cancel": "Cancel"
      },
      "reasons": {
        "no_longer_used": "No longer used",
        "wrong_account": "Wrong account linked",
        "security_concern": "Security concern",
        "duplicate": "Duplicate account",
        "other": "Other"
      },
      "success": "Bank account disabled successfully",
      "error": "Failed to disable bank account",
      "errorActiveTransfers": "Cannot disable account with active or pending transfers"
    }
  },
  "accountTypes": {
    "checking": "Checking",
    "savings": "Savings",
    "depository": "Depository"
  },
  "companyBankAccounts": {
    "title": "Company Bank Account",
    "connectTitle": "Connect Company Bank Account",
    "warning": {
      "title": "Company Bank Account",
      "description": "This will connect the company's bank account for deposits and payouts. Only authorized administrators should perform this action."
    },
    "emptyState": {
      "title": "No Company Bank Account Connected",
      "description": "Connect the company's bank account to enable funding deposits and processing withdrawals.",
      "connectButton": "Connect Company Bank Account"
    },
    "connected": {
      "title": "Company Bank Account Connected",
      "description": "The company bank account is linked and ready for transactions",
      "comingSoon": "Account details and management options coming soon"
    },
    "connect": {
      "title": "Connect Company Bank Account",
      "description": "Securely link the company bank account. This will be used as the source for deposits and destination for withdrawals.",
      "button": "Connect Company Bank Account",
      "initializing": "Initializing company bank connection...",
      "connecting": "Connecting company bank account...",
      "success": "Company bank account connected successfully!",
      "error": {
        "title": "Connection Error",
        "retry": "Try Again",
        "initFailed": "Failed to initialize company bank connection",
        "connectFailed": "Failed to connect company bank account"
      }
    },
    "list": {
      "addAccountButton": "Add Account",
      "syncButton": "Refresh Accounts",
      "noAccounts": "No accounts found. Click refresh to sync from bank.",
      "fetchError": "Failed to load company bank accounts",
      "syncSuccess": "Company bank accounts synced successfully",
      "syncError": "Failed to sync company bank accounts"
    },
    "reconnect": {
      "badge": "Disconnected",
      "button": "Reconnect",
      "modal": {
        "title": "Reconnect Company Bank Account",
        "description": "The company's bank connection has been disconnected. You'll need to log in again to restore access to the company bank accounts.",
        "confirm": "Reconnect Now",
        "cancel": "Cancel"
      },
      "success": "Company bank account reconnected successfully",
      "error": "Failed to reconnect company bank account"
    },
    "default": {
      "badge": "Default",
      "setButton": "Set as Default",
      "setSuccess": "Default company bank account updated successfully",
      "setError": "Failed to set default company bank account",
      "missing": {
        "title": "No Default Source Account Configured",
        "description": "Please set a default company bank account to enable deposits and payouts. Click 'Set as Default' on any active account."
      }
    },
    "disable": {
      "button": "Disable",
      "modal": {
        "title": "Disable Company Bank Account",
        "description": "Are you sure you want to disable this company bank account? It will no longer be available for transactions.",
        "reasonLabel": "Reason",
        "reasonPlaceholder": "Select a reason",
        "reasonTextLabel": "Additional details (optional)",
        "reasonTextPlaceholder": "Provide more information...",
        "replacementLabel": "Set new default account",
        "replacementPlaceholder": "Select a replacement",
        "replacementNote": "This account is currently the default. Please select a new default or the default will be cleared.",
        "confirm": "Disable Account",
        "cancel": "Cancel"
      },
      "reasons": {
        "no_longer_used": "No longer used",
        "wrong_account": "Wrong account linked",
        "security_concern": "Security concern",
        "duplicate": "Duplicate account",
        "other": "Other"
      },
      "success": "Company bank account disabled successfully",
      "error": "Failed to disable company bank account",
      "errorActiveTransfers": "Cannot disable account with active or pending transfers"
    }
  }
}

